import { default as logo } from "./assets/logo.png";
import Navigation from "./components/Navigation";
import { Box } from "@mui/material";
import Home from "./pages/Home";
import { useEffect, useState } from "react";
import { theme } from "./common/style/Theme";
import Footer from "./components/Footer";
import { AccountTree, AddModerator, Api, AutoAwesome, Build, Business, Cloud, CloudDone, CloudSync, CloudUpload, DesignServices, Domain, Handshake, HealthAndSafety, MeetingRoom, MobileScreenShare, MonetizationOn, PeopleAlt, PermDataSetting, PhoneIphone, School, ShoppingCart, Stream} from "@mui/icons-material";
import About from "./pages/About";
import { Route, Routes } from "react-router-dom";
import Offerings from "./pages/Offerings";
import Industries from "./pages/Industries";
import Platform from "./pages/Platforms";
import Contact from "./pages/Contact";
import Collaborations from "./pages/Collaborations";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Disclaimer from "./pages/Disclaimer";

const App = () => {
  const [navBg, setNavBg] = useState("transparent")
  const [navTextColor, setNavTextColor] = useState(theme.palette.common.white)

  window.addEventListener("scroll", () => {
      if(window.scrollY > 20) {
          setNavBg(theme.palette.common.white)
          setNavTextColor(theme.palette.text.primary)
      }
      else {
        setNavBg("transparent")
        setNavTextColor(theme.palette.common.white)
      }
  })

  useEffect(() => {
    if (window.location.pathname === "/platforms") {
      setNavBg(theme.palette.common.white)
      setNavTextColor(theme.palette.text.primary)
    }
    // eslint-disable-next-line
  }, [window.location.pathname]);

  return (
    <Box>
      <Navigation
        title="Ideas to Impact"
        logo={logo}
        navItems={
          [
            { name: "Company", link: "/about", isMenu: true, 
                menuItems: [
              { name: "Company", icon: <Business />, 
                title: "M5 Info Solutions",
                description: "Empowering Businesses with Innovative Solutions",
                menuOptions: [
                  { name: "About Us", icon: <MeetingRoom />, link: "/about" },
                  { name: "Collaborations", icon: <Handshake />, link: "/collaborations" },
                  { name: "Why Choose M5", icon: <Handshake />, link: "/whym5" },
                ]
              }
            ]
          },
            { name: "Offerings", link: "/offerings", isMenu: true, menuItems: [
              { name: "Core Software Development", icon: <AccountTree />, 
                title: "Core Software Development Areas",
                description: "At M5 Info Solutions, we specialize in designing smart, scalable, and intuitive software solutions that cater to businesses across sectors. Whether you're a startup, SME, or a growing enterprise, our modular approach ensures that your systems are built to fit your unique business model and future growth.",
                menuOptions: [
                  { name: "Mobile Apps for All Industries", icon: <MobileScreenShare />, link: "/offerings/mobile" },
                  { name: "eCommerce & Marketplace Integration", icon: <Build />, link: "/offerings/ecommerce" },
                  { name: "UI/UX Design & Prototype Building", icon: <CloudSync />, link: "/offerings/ui-ux" },
                  { name: "Third-party Integrations",  icon: <CloudDone />, link: "/offerings/integrations" },
                ] 
              },
              { 
                name: "Enterprise Systems and Process",
                icon: <PermDataSetting />,
                title: "Enterprise Systems and Process",
                description: "At M5 Info Solutions, we specialize in designing and implementing enterprise systems and processes that are tailored to the unique needs of our clients. We understand that every business is different, and we work closely with our clients to design and implement systems and processes that are tailored to their specific needs.",
                menuOptions: [
                  { name: "Full-stack Development", icon:  <AddModerator />, link: "/offerings/full-stack" },
                  { name: "Business Process Mapping", icon:  <CloudUpload />, link: "offerings/bpm"},
                  { name: "Workflow Automation & Dashboards", icon: <Api />, link: "/offerings/workflow" },
                  { name: "CustomERP & SaaS Development", icon: <PermDataSetting />, link: "/offerings/erp" },
                ]
              },
              { name: "Consulting & Digital Services", icon: <Cloud />, 
                title: "Consulting & Digital Services",
                description: "At M5 Info Solutions, we empower businesses, platforms, and changemakers with end-to-end digital consulting and development services. Whether you’re a manufacturer, a distributor, a logistics partner, a value chain enabler, or a mission-driven organization — we help you design, build, and scale solutions that create impact and drive growth.",
                menuOptions: [
                  { name: "AI-enabled Tools & Smart Systems", icon: <AutoAwesome />, link: "offerings/ai-tools" },
                  { name: "Data Intelligence & Reporting Modules", icon: <DesignServices />, link: "/offerings/data-intelligence" },
                  { name: "Digital Marketing & SEO", icon: <Stream />, link: "/offerings/digital-marketing" },
                  { name: "Tech Partnership Models", icon: <PermDataSetting />, link: "/offerings/partnerships" },
                ] 
              },
            ]},
            { name: "Industries", link: "/industries", isMenu: true, 
              menuItems: [{
                name: "Domain", icon: <Domain />,
                title: "Industries We Serve",
                description: "At M5 Info Solutions, we believe every industry deserves purpose-driven digital solutions. Our experience spans across sectors — from traditional manufacturing to mission-driven rural enterprises — and we specialize in building technology that is adaptable, scalable, and impactful. Whether you're transforming supply chains, building platforms, or empowering communities, we work with you to co-create digital tools that drive value.",
              menuOptions: [
                { name: "Agriculture & Allied Sectors", icon: <School />, link: "industries/agriculture" },
                { name: "Distribution & Supply Chain", icon: <MonetizationOn />, link: "industries/distribution" },
                { name: "Retail & eCommerce", icon: <Build />, link: "industries/retail" },
                { name: "Service-based Enterprises", icon: <ShoppingCart />, link: "industries/service-based" },
                { name: "Rural & Social Enterprises", icon: <PhoneIphone />, link: "industries/rural" },
                { name: "Manufacturing & Processing", icon: <HealthAndSafety />, link: "industries/manufacturing" },
                { name: "Public Sector & Development Programs", icon: <PeopleAlt />, link: "industries/public-sector" },
            ]}]},
            { name: "Platforms", link: "/platforms", isMenu: false },
            { name: "Contact", link: "/contact", isMenu: false },
          ]
        }
        mainLink="/"
        navBg={navBg}
        setNavBg={setNavBg}
        navTextColor={navTextColor}
        setNavTextColor={setNavTextColor}
      />
      <Box>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/collaborations" element={<Collaborations />} />
          <Route path="/offerings/:id" element={<Offerings />} />
          <Route path="/industries/:id" element={<Industries />} />
          <Route path="/platforms" element={<Platform />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </Box>
      <Footer 
        navItems={
          [
            { name: "Company", link: "/about", isMenu: true, menuItems: [
              { name: "About Us", link: "/about" },
              { name: "Collaborations", link: "/collaborations" },
              { name: "Why Choose M5", link: "/whym5" },
              { name: "Platform", link: "/platforms" },
            ] },
            { name: "Offerings", link: "/offerings", isMenu: true, menuItems: [
              { name: "Mobile Apps for All Industries", link: "/offerings/mobile" },
              { name: "eCommerce & Marketplace Integration", link: "/offerings/ecommerce" },
              { name: "UI/UX Design & Prototype Building", link: "/industries/ui-ux" },
              { name: "Third-party Integrations", link: "/industries/integrations" },
              { name: "Full-stack Development", link: "/industries/full-stack" },
              { name: "Business Process Mapping", link: "industries/bpm"},
              { name: "Workflow Automation & Dashboards", link: "/offerings/workflow" },
              { name: "⁠Custom ERP & SaaS Development", link: "/offerings/erp" },
              { name: "AI-enabled Tools & Smart Systems", link: "offerings/ai-tools" },
              { name: "Data Intelligence & Reporting Modules", link: "/offerings/data-intelligence" },
              { name: "Digital Marketing & SEO", link: "/industries/digital-marketing" },
              { name: "Tech Partnership Models", link: "/industries/partnerships" },
            ]},
            { name: "Industries", link: "/industries", isMenu: true, menuItems: [
              { name: "Agriculture & Allied Sectors", link: "industries/agriculture" },
              { name: "Distribution & Supply Chain", link: "industries/distribution" },
              { name: "Retail & eCommerce", link: "industries/retail" },
              { name: "Service-based Enterprises", link: "industries/service-based" },
              { name: "Rural & Social Enterprises", link: "industries/rural" },
              { name: "Manufacturing & Processing", link: "industries/manufacturing" },
              { name: "Public Sector & Development Programs", link: "industries/public-sector" },
            ]},
          ]
        }
      />
    </Box>
  )
}

export default App;
